import { useModuleContext } from "../model/context";

function useModuleConnection() {
  const { modules } = useModuleContext();

  const checkIsModuleConnected = (moduleId?: string) =>
    !!modules?.find(({ module }) => module === moduleId);

  return { checkIsModuleConnected };
}

export function useIsModuleConnected(moduleId: string) {
  const { checkIsModuleConnected } = useModuleConnection();

  return checkIsModuleConnected(moduleId);
}

export function useIsModuleConnectedFn() {
  const { checkIsModuleConnected } = useModuleConnection();

  return checkIsModuleConnected;
}
